import React, { FC, PropsWithChildren } from "react";
import { ButtonProps, Dialog } from "@xapp/components";

import { IntegrationList, IntegrationListProps } from "./IntegrationList";

export interface IntegrationsListDialogProps extends IntegrationListProps {
    /**
     * Dialog is active
     */
    active?: boolean;
    /**
     * List of integrations to show.
     */
    integrations: string[];
    /**
     * User cancelled the dialog
     */
    onCancel?(): void;
}

/**
 * The "Add Integration" picker.
 *
 * Deliberately NOT react-toolbox's Dialog: that one portals through
 * ReactDOM.unstable_renderSubtreeIntoContainer, which mounts a separate React root, so every
 * provider above it — urql, redux, the theme — is missing for whatever renders inside. The cards
 * themselves never needed context, so it went unnoticed until ServiceTitanConnectDialog called a
 * urql hook in here and threw "No client has been specified using urql's Provider". The
 * @xapp/components Dialog is MUI-backed and portals with createPortal, which keeps context intact.
 */
export const IntegrationsListDialog: FC<PropsWithChildren<IntegrationsListDialogProps>> = (
    props: IntegrationsListDialogProps
) => {
    const { active, integrations, onCancel } = props;

    const dialogActions: ButtonProps[] = [
        {
            label: "Done",
            onClick: onCancel,
        },
    ];

    return (
        <Dialog
            title="Add Integration"
            active={!!active}
            actions={dialogActions}
            onClose={onCancel}
            maxWidth="md"
            fullWidth
        >
            <IntegrationList {...props} limitIntegrations={integrations} onboardingMode={true} />
        </Dialog>
    );
};
